/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { getStoreBuilder } from 'vuex-typex';
const storeBuilder = getStoreBuilder();
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
const makeInitialState = () => ({
    fontSize: 12,
    contextAmount: 3,
});
const moduleBuilder = storeBuilder.module('pref', makeInitialState());
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var PreferenceStore;
(function (PreferenceStore) {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PreferenceStore.fontSize = moduleBuilder.read(state => state.fontSize, 'fontSize');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PreferenceStore.contextAmount = moduleBuilder.read(state => state.contextAmount, 'contextAmount');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PreferenceStore.setFontSize = moduleBuilder.commit((state, newFontSize) => {
        state.fontSize = newFontSize;
    }, 'setFontSize');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    PreferenceStore.setContextAmount = moduleBuilder.commit((state, newContextAmount) => {
        state.contextAmount = newContextAmount;
    }, 'setContextAmount');
})(PreferenceStore || (PreferenceStore = {}));
